import { useQuery } from 'react-query';
import {
  fetchPretaxClaims,
  FetchPretaxClaimsResponse,
} from 'apis/pretaxV2Claim';

// using default page size since pagination is not yet implemented
const DEFAULT_PAGE_SIZE = 100;

export type IPretaxV2Claim = FetchPretaxClaimsResponse[0];

const getPretaxClaims = async (query: {
  page: number;
  size: number;
  status?: string | null;
}) => {
  const response = await fetchPretaxClaims(query);
  return response.data;
};

const useQueryPretaxV2Claims = ({
  size = DEFAULT_PAGE_SIZE,
  page = 1,
  status = undefined,
  is_pretax_v2_enabled,
  onError,
}: {
  size?: number;
  page?: number;
  status?: string | null;
  is_pretax_v2_enabled?: boolean;
  onError: () => void;
}) => {
  const { data, isIdle, isLoading, isSuccess } = useQuery(
    ['getPretaxClaims', status],
    () => getPretaxClaims({ size, page, status }),
    {
      enabled: is_pretax_v2_enabled,
      onError,
    }
  );

  return {
    data,
    isIdle,
    isLoading,
    isSuccess,
  };
};

export default useQueryPretaxV2Claims;
